import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';
import { Button } from 'antd';

import './style.scss';

const NotFound = () => {
	const navigate = useNavigate();
	const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });

	const handleBackHome = () => {
		navigate('/');
	};

	return (
		<div className={clsx('not-found', { 'not-found--mobile': isMobile })}>
			<p className="not-found__code">404</p>
			<div className="not-found__divider" />
			<h1 className="not-found__title">Halaman Tidak Ditemukan</h1>
			<p className="not-found__description">
				Maaf, halaman yang kamu cari tidak tersedia atau sudah dipindahkan.
				Silakan kembali ke halaman utama.
			</p>
			<Button
				type="primary"
				className="not-found__button"
				onClick={handleBackHome}
			>
				Kembali ke Beranda
			</Button>
		</div>
	);
};

export default NotFound;
